export default class CustomReportController
{
	constructor($scope, $timeout, $http, $location, AppService, DateRangeService, DataTableService, ChartService) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$http = $http;
		this.AppService = AppService;
		this.DataTableService = DataTableService;
		this.DateRangeService = DateRangeService;
		this.ChartService = ChartService;

		// Set page title
		this.$scope.$parent.title = this.title;

		// Set page endpoint
		this.$scope.$parent.endpoint = this.endpoint;

		// Initialising chart renderers
		this.ChartService.create('chart');

		// Register events
		this.$scope.$on('base-range-update', () => { this.updateBaseData() });

		this.baseData = null;

		// Set default group_by
		this.groupBy = 'organisation_id';

		this.filters = {};

		if ($('#overview-chart').length) {
			this.ChartService.createOverview('overview-chart');
		}
	}

	get endpoint() {
		return 'custom';
	}

	get title() {
		return 'Custom Report';
	}

	setPeriod(period) {
		if (period !== this.AppService.period) {
			this.AppService.period = period;
			this.updateData();
		}
	}

	generate() {
		this.updateBaseData();
	}

	clear() {
		this.filters = {};
	}

	updateData() {
		this.updateBaseData();
	}

	updateBaseData() {
		this.getDataFromApi(
			this.filters,
			this.groupBy,
			this.DateRangeService.startDate.format('YYYY-MM-DD'),
			this.DateRangeService.endDate.format('YYYY-MM-DD'),
			(body) => {
				this.baseData = body.data;
				this.ChartService.updateBaseData(this.formatChartData(this.groupBy, this.baseData));
				this.$timeout(() => {
					this.ChartService.reflow();
				}, 1);

			}
		);
	}

	formatChartData(category, data) {
		var categoryName = category.split('_')[0]+'_name';
		var formattedData = [];
		for (let row of data) {
			formattedData.push([row[categoryName], parseInt(row.total)]);
		}
		return formattedData;
	}

	getDataFromApi(filters, groupBy, startDate, endDate, callback) {
		this.$http({
			method: 'POST',
			url: '/api/custom',
			data: {
				start_date: startDate,
				end_date: endDate,
				period: this.AppService.period,
				filters: filters,
				group_by: groupBy
			},
			async: false,
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(
			(response) => {
				callback(response.data);
			},
			(response) => {
				alert('Unable to get report data');
				console.log(response);
			}
		);
	}

	getOverviewData(groupBy, row) {

		var selector = groupBy.split('_');
		var endpoint = (selector[0] == 'organisation') ? 'organisation-pax' : selector[0];
		var category = row[selector[0]+'_name'];

		this.getOverviewDataFromApi(
			endpoint,
			category,
			this.DateRangeService.startDate.format('YYYY-MM-DD'),
			this.DateRangeService.endDate.format('YYYY-MM-DD'),
			this.filters,
			(body) => {
				this.ChartService.updateOverviewBaseData(body.data);
			}
		);
	}

	getOverviewDataFromApi(endpoint, category, startDate, endDate, filters, callback) {
		this.$http({
			method: 'GET',
			url: '/api/'+endpoint+'/overview',
			params: {
				category: category,
				start_date: startDate,
				end_date: endDate,
				filters: filters,
				period: this.AppService.period
			},
			async: false,
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(
			(response) => {
				callback(response.data);
			},
			(response) => {
				alert('Unable to get overview report data');
				console.log(response);
			}
		);
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/custom.report.controller.js
 **/